import React from "react";

function ViewNotification({ data }) {
  if (!data) {
    return (
      <div className="main_page">
        <div className="row">
          <div className="col-md-12 text-center mb-4">
            <p>No notification data available.</p>
          </div>
        </div>
      </div>
    );
  }

  // Extract nested data safely
  const notificationData = data?.data || {};

  // Format dates nicely
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div>
      {/* <div className="main_page"> */}
        <div className="row">
          {/* Header */}
          <div className="col-md-12 text-center mb-4">
            <h4>{data?.title || "Notification"}</h4>
            <p className="text-muted">{data?.message}</p>
          </div>

          {/* Sender Info */}
          <div className="col-md-6 mb-3">
            <label>Sender ID</label>
            <input
              type="text"
              className="form-control"
              value={data?.sender_id || "-"}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Sender Type</label>
            <input
              type="text"
              className="form-control"
              value={data?.sender_type || "-"}
              disabled
            />
          </div>

          {/* Notification Type & Priority */}
          <div className="col-md-6 mb-3">
            <label>Type</label>
            <input
              type="text"
              className="form-control"
              value={data?.type || "-"}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Priority</label>
            <input
              type="text"
              className="form-control"
              value={data?.priority || "-"}
              disabled
            />
          </div>

          {/* Vendor Details */}
          <div className="col-md-6 mb-3">
            <label>Vendor ID</label>
            <input
              type="text"
              className="form-control"
              value={notificationData?.vendor_id || "-"}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Vendor Name</label>
            <input
              type="text"
              className="form-control"
              value={notificationData?.vendor_name || "N/A"}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Phone</label>
            <input
              type="text"
              className="form-control"
              value={notificationData?.phone || "-"}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Module Name</label>
            <input
              type="text"
              className="form-control"
              value={notificationData?.module_name || "-"}
              disabled
            />
          </div>

          {/* Reference Info */}
          <div className="col-md-6 mb-3">
            <label>Reference ID</label>
            <input
              type="text"
              className="form-control"
              value={data?.reference_id || "-"}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label>Reference Type</label>
            <input
              type="text"
              className="form-control"
              value={data?.reference_type || "-"}
              disabled
            />
          </div>

          {/* Action URL */}
          {/* <div className="col-md-12 mb-3">
            <label>Action URL</label>
            <input
              type="text"
              className="form-control"
              value={data?.action_url || "-"}
              disabled
            />
          </div> */}

          {/* Timestamps */}
          <div className="col-md-4 mb-3">
            <label>Created At</label>
            <input
              type="text"
              className="form-control"
              value={formatDate(data?.created_at)}
              disabled
            />
          </div>
          <div className="col-md-4 mb-3">
            <label>Updated At</label>
            <input
              type="text"
              className="form-control"
              value={formatDate(data?.updated_at)}
              disabled
            />
          </div>
          <div className="col-md-4 mb-3">
            <label>Read At</label>
            <input
              type="text"
              className="form-control"
              value={data?.read_at ? formatDate(data.read_at) : "Unread"}
              disabled
            />
          </div>
        </div>
      </div>
    // </div>
  );
}

export default ViewNotification;